<template>
  <div class="center-popup-component">
    <ym-popup class="popup"
              v-model="visible"
              :class="[
                `size-${size}`,
                `type-${type}`,
              ]"
              :style="popupBg ? `background: ${popupBg};` : ''"
              :close-on-click-overlay="closeOnClickOverlay"
              get-container="body"
    >
      <div class="popup-header"
           :style="`background: ${headerBg};`"
           v-if="title !== ''"
      >
        {{ title }}
      </div>
      <div class="popup-content">
        <slot></slot>
      </div>
      <div class="popup-close"
           @click.stop="handleClose(visible)"
      >
        <ym-icon name="round-close" />
      </div>
    </ym-popup>
  </div>
</template>

<script>
  import { Popup } from '@ymba/ym-ui';

  export default {
    name: 'CenterPopup',
    components: {
      'ym-popup': Popup,
    },
    data() {
      return {
        visible: false,
      };
    },
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      title: {
        type: String,
        default: '',
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: true,
      },
      type: {
        type: String,
        default: 'default',
      },
      size: {
        type: String,
        default: 'middle',
        validator(val) {
          return [
            'middle',
            'large',
          ].includes(val);
        },
      },
      headerBg: {
        type: String,
        default: '#fff',
      },
      popupBg: {
        type: String,
        default: '',
      },
    },
    watch: {
      show(val) {
        this.visible = val;
      },
      visible(val) {
        this.$emit('update:show', val);
      },
    },
    methods: {
      handleClose() {
        this.visible = false;
        this.$emit('closeCenterPopup');
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .popup {
    border-radius: 16px;
    width: 570px;
    overflow-y: visible;
    &.type-gradient {
      .popup-header {
        background: @gradient-highlight-secondary;
        color: @color-white;
        text-shadow: @gradient-highlight-secondary-text-shadow;
      }
    }
    &.size-large {
      width: 630px;
    }
  }

  .popup-close {
    position: absolute;
    bottom: -2 * @size-extra-medium;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: @size-large;
    height: @size-large;
    font-size: @size-large;
    color: @color-placeholder;
  }

  .popup-header {
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    font-size: @font-size-large;
    font-weight: @font-weight-bold;
    height: @popup-header-height;
    border-bottom: @border-base;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    white-space: nowrap;
    background-color: @color-white;
    color: @color-text-base;
  }

  .popup-content {
    text-align: center;
  }

  .popup-footer {
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
  }
</style>
